export const shortenAddress = (address) => {
  if (!address) return '';
  return address.slice(0, 6) + '...' + address.slice(-4);
};

export const formatUSDT = (value) => {
  if (!value) return '0.00';
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDate = (timestamp) => {
  if (!timestamp) return '-';
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getActivityLabel = (type) => {
  const labels = {
    0: 'Registration',
    1: 'Upgrade',
    2: 'Sponsor Income',
    3: 'Level Income',
    4: 'Pool Income',
    5: 'Claim',
    6: 'Re-Topup',
  };
  return labels[type] || 'Unknown';
};

export const getActivityColor = (type) => {
  const colors = {
    0: '#00E5FF',
    1: '#7B61FF',
    2: '#00C9A7',
    3: '#FFB800',
    4: '#FF2D95',
    5: '#00FF88',
    6: '#FF6B35',
  };
  return colors[type] || '#888';
};
